import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../../_metronic/helpers'
import {User, ContractsQueryResponse, Contracts} from './_models'
import {ClearStorage} from '../../../../../../../util/clearStorage'

const API_URL = process.env.REACT_APP_API_URL || 'api'
const USER_URL = `${API_URL}/user`

//BUSCA TOKEN NO LOCALSTORAGE
let token = localStorage.getItem('auth_storage')
if (token) token = token.replace(/['"]+/g, '')
let config = {
  headers: {
    Authorization: 'Bearer ' + token,
  },
}
const getContracts = async (query: string): Promise<ContractsQueryResponse> => {
  //requisição banco de dados
  let logs = await axios
    // .get(API_URL + '/sga/sga/v1/Contractsall_Contracts?' + query, config)
    .get(API_URL + '/sgt/v1/contracts?' + query, config)
    .then((response: AxiosResponse<Response<ContractsQueryResponse>>) => response.data as any)
    .catch((error) => {
      if (error.response.status === 401) {
        ClearStorage()
      }
    })
  let data = (await logs) as any

  let data2 = {
    data: data.data,
    payload: {
      pagination: {
        page: data.current_page,
        links: data.links,
      },
    },
  }
  return data2 as any
}

const createContracts = async (Contracts: Contracts): Promise<Contracts | undefined> => {
  let logs = await axios
    .post(API_URL + '/sgt/v1/contracts', Contracts, config)
    .then((response: AxiosResponse<Response<ContractsQueryResponse>>) => response.data)
    .catch()

  return logs as any
}

const updateContracts = async (Contracts: Contracts): Promise<Contracts | undefined> => {
  let logs = await axios
    .put(API_URL + '/sgt/v1/contracts' + Contracts.uuid, Contracts, config)
    .then((response: AxiosResponse<Response<Contracts>>) => response.data)
    .then((response: Response<Contracts>) => response.data)
  return logs as any
}

const deleteContracts = (ContractsId: string): Promise<void> => {
  return axios.delete(API_URL + '/sgt/v1/contracts' + ContractsId, config).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const getUserById = (id: ID): Promise<User | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}
export {
  getContracts,
  deleteContracts,
  deleteSelectedUsers,
  getUserById,
  createContracts,
  updateContracts,
}
